import { useEffect, useState } from "react";
import { enablePush } from "../../../firebase";
import { checkLocalStorageForDeviceID } from "./PushHelpers";
import PilotApiRepository from "../../../repositories/api/PilotApiRepository";
import { Dialog } from "../../../components/layout/dialogs/Dialog";
import { DialogProperties } from "../../../components/layout/dialogs/DialogProperties";
import { isNullOrEmpty } from "../../../components/helpers/ObjectHelpers";
import { isSupported } from "firebase/messaging";
import { useErrorNotification } from 'components/hooks/useAppStore';

function PushPermissionDialog({ onClose }) {
    const [supportLevel, setSupportLevel] = useState(null);
    const addErrorNotification = useErrorNotification();

    useEffect(() => {
        const determineSupportLevel = async () => {
            if (!(await isSupported())) {
                setSupportLevel("unsupported");
            } else {
                if (window?.Notification?.permission === "denied") {
                    setSupportLevel("denied");
                } else {
                    setSupportLevel("default");
                }
            }
        };
        determineSupportLevel();
    }, []);

    function handleClose() {
        onClose();
    }

    async function handleAllowPush() {
        handleClose();

        const deviceId = checkLocalStorageForDeviceID();

        if (!isNullOrEmpty(deviceId)) {
            const response = await PilotApiRepository.refreshPushSubscriptionsAsync(deviceId);
            if (!response.ok) {
                addErrorNotification("Kunne ikke oppdatere push-varsler for enheten.");
            }
        } else {
            const response = await PilotApiRepository.registerDeviceAsync();
            if (response.ok) {
                const id = await response.json();
                localStorage.setItem("deviceId", String(id));
            } else {
                addErrorNotification("Kunne ikke registrere enheten for push-varsler.");
            }
        }
        // enablePush may prompt for permission; close after it's resolved
        await enablePush();
    }

    switch (supportLevel) {
        case "unsupported":
            return (null);
        case "denied":
            return (
                <Dialog
                    properties={{
                        ...DialogProperties,
                        title: "Push-varsler er deaktivert",
                        className: "dialog-title",
                        onClose: handleClose,
                    }}
                >
                    <div>Du har deaktivert push-varsler i din nettleser.</div>
                    <div>
                        For å motta push-varsler må dette aktiveres gjennom &quot;innstillinger&quot; i din nettleser.
                    </div>
                </Dialog>
            );
        default:
            return (
                <Dialog
                    properties={{
                        ...DialogProperties,
                        mode: "confirmation",
                        title: "Ønsker du å tillate push-varsler?",
                        className: "dialog-title",
                        onClick: handleAllowPush,
                        onClose: handleClose,
                    }}
                >
                    <div>
                        Etter godkjenning må du via &quot;innstillinger&quot; velge hvilke varsler du vil abonnere på.
                    </div>
                </Dialog>
            );
    }
}

export default PushPermissionDialog;
